__turbopack_context__.v({
  "btnContainer": "PaginationSection-module-scss-module__IPTvmG__btnContainer",
  "btnContainerSelected": "PaginationSection-module-scss-module__IPTvmG__btnContainerSelected",
  "container": "PaginationSection-module-scss-module__IPTvmG__container",
});
